import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./vuetify";
import i18n from "./i18n/i18n";
import Toaster from "./toaster/ToasterPlugin";
import "./axios";
import * as VueGoogleMaps from "vue2-google-maps";
import "./firebase/fcm";
import VueDictaphone from "vue-dictaphone";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCrU-gNRP8xFL04CwSAgpu_gQwH3VFn7OY",
    libraries: "places",
    language: localStorage.lang ?? "ar",
  },
});

Vue.use(Toaster);
Vue.use(VueDictaphone);

Vue.directive("clickoutside", {
  bind: (el, binding, vnode) => {
    setTimeout(() => {
      el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
      document.body.addEventListener("touchstart", el.clickOutsideEvent);
    }, 0);
  },
});

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: (h) => h(App),
  created() {
    this.$store
      .dispatch("initialize")
      .catch((e) => console.error("store initialize error:", e));
  },
}).$mount("#app");
